import * as constants from './constants';
import * as types from './types';
import { mapFiltersToState } from '../../common/filters/utils';
import { createFiltersReducer } from '../../common/filters/reducers';

const { initialState, reducer } = createFiltersReducer(
  types,
  constants.FILTERS_MAP,
  mapFiltersToState,
);

export default reducer;
export { initialState };
